import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Gauge, Calendar } from "lucide-react";
import { CheckCircle2, Activity } from "lucide-react";

export function ProjectBanner({ project }) {
  const isCompleted = project.status === "Completed";
  return (
    <section className="ye-project-banner" style={{ backgroundImage: `url(${project.image})` }} data-testid="project-banner">
      <div className="ye-container">
        <span className="ye-eyebrow">Project</span>
        <h1 className="ye-display ye-h1" style={{ margin: "8px 0 22px", color: "#fff" }}>{project.title}</h1>
        <div className="ye-project-meta-row">
          <span className="ye-meta-chip"><MapPin size={14} /> {project.location}</span>
          <span className="ye-meta-chip"><Gauge size={14} /> {project.capacity}</span>
          <span className="ye-meta-chip"><Calendar size={14} /> {project.year}</span>
          <span className={`ye-meta-chip ye-status-${isCompleted ? "completed" : "ongoing"}`}>{project.status}</span>
        </div>
      </div>
    </section>
  );
}

export function ProjectScope({ scope }) {
  return (
    <>
      <h2 className="ye-display ye-h3" style={{ fontSize: "1.5rem", margin: "0 0 16px" }}>Scope Delivered</h2>
      <ul className="ye-check-list">
        {scope.map((item) => (
          <li key={item}>
            <CheckCircle2 size={18} style={{ color: "var(--orange)", flexShrink: 0, marginTop: 2 }} />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </>
  );
}

export function ProjectSidebar({ project }) {
  return (
    <aside className="ye-project-sidebar">
      <h3 className="ye-h3" style={{ margin: "0 0 18px", fontSize: "1.1rem" }}>Project Facts</h3>
      <dl className="ye-fact-list">
        <div><dt>Location</dt><dd>{project.location}</dd></div>
        <div><dt>Capacity</dt><dd>{project.capacity}</dd></div>
        <div><dt>Year</dt><dd>{project.year}</dd></div>
        <div><dt>Status</dt><dd>{project.status}</dd></div>
        <div><dt>Services</dt><dd>{project.services.join(", ")}</dd></div>
      </dl>
      <Link to="/contact" className="ye-btn ye-btn-primary" style={{ width: "100%", marginTop: 18 }} data-testid="similar-project-cta">
        Discuss a Similar Project <ArrowRight size={14} />
      </Link>
    </aside>
  );
}

export function ProjectHighlights({ highlights }) {
  return (
    <div style={{ marginTop: 60 }}>
      <h2 className="ye-display ye-h3" style={{ fontSize: "1.5rem", margin: "0 0 20px" }}>Execution Highlights</h2>
      <div className="ye-grid-3">
        {highlights.map((h) => (
          <div className="ye-highlight-card" key={h.t}>
            <Activity size={28} style={{ color: "var(--orange)", marginBottom: 12 }} />
            <div style={{ fontFamily: "Archivo", fontWeight: 800, color: "var(--navy)", fontSize: "1.1rem", lineHeight: 1.25 }}>
              {h.t}
            </div>
            {h.d && <div style={{ color: "var(--ink)", marginTop: 4, fontSize: 14.5 }}>{h.d}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
